import { isApiError } from '@/shared/api'

/** Коды подарка с особой реакцией экрана (`GiftExceptionCode` бэкенда). */
export const GIFT_ERROR_CODE = {
  NOT_FOUND: 'GF-001',
  /**
   * Подарок не этого человека: чужой, несуществующий или уже не его. Бэкенд
   * отвечает одинаково, чтобы не подтверждать существование чужого подарка.
   */
  NOT_VISIBLE: 'GF-003',
  /**
   * «По этому подарку решение уже не принять» (BE-51): на «Принять» — человек
   * отказался, подарок вернулся по таймауту или деньги возвращены; на
   * «Отказаться» — подарок уже принят. Экран отличает это от чужого подарка.
   */
  DECISION_CLOSED: 'GF-004',
} as const

/** Коды возврата денег (`RefundExceptionCode` бэкенда), на которые экран дарителя отвечает своим текстом. */
export const REFUND_ERROR_CODE = {
  /** Статус подарка не допускает возврата. Кнопкой — только `PAID`; бэкенд отвечает так и на гонку. */
  NOT_REFUNDABLE: 'RF-002',
  /** Деньги уже возвращены — второй тап, другое устройство. */
  ALREADY_REFUNDED: 'RF-003',
  /** Провайдер отказал в возврате: деньги остались у нас, подарок не тронут. */
  PROVIDER_REJECTED: 'RF-004',
  /** Погашенный ваучер не возвращается. */
  REDEEMED: 'RF-005',
} as const

/** Подарок недоступен этому человеку — «Ой! Подарок не найден», а не ошибка. */
export const isGiftTakenError = (error: unknown): boolean =>
  isApiError(error) && (error.code === GIFT_ERROR_CODE.NOT_VISIBLE || error.code === GIFT_ERROR_CODE.NOT_FOUND)

/** Решение по подарку уже не принять (`GF-004`). */
export const isDecisionClosedError = (error: unknown): boolean =>
  isApiError(error) && error.code === GIFT_ERROR_CODE.DECISION_CLOSED
